var ExpandTableRowsType = {
  None: "none",
  OnClick: "onClick",
  Always: "always",
  Never: "never"
};
var TableSelectableColumnHeader = {
  Hide: "hide",
  Page: "page",
  All: "all"
};
var TableMenuDirection = {
  Left: "left",
  Right: "right"
};

export { ExpandTableRowsType, TableMenuDirection, TableSelectableColumnHeader };
